// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1LDyA","notes":"Notes_notes__25Mi5","note":"Notes_note__Wavnp","markdown":"Notes_markdown__vfe9o"};